angular.module('buildingSpecialistsModule', ['buildingSpecialistsTemplates', 'LocalStorageModule']);

angular.module('buildingSpecialistsModule').config(['localStorageServiceProvider',function (localStorageServiceProvider) {
	localStorageServiceProvider.setPrefix('crApp');
}]);
